// src/components/SideBar/index.js
import SideBar from './SideBar';
export default SideBar;